module.exports = __webpack_public_path__ + "media/tick1.720aafd6.mp3";